// extracted by mini-css-extract-plugin
export default {"paragraph":"_Paragraph_paragraph__C6C-I"};